import * as types from '../mutation-types'
import * as consts from '../../data/base/consts'
import { API } from '../../api'
import { DIAGRAM_DATA_MANAGER, DATA } from '../../data'
import { MOMENT_TIME } from '../../momenttime'

export default {
    namespaced: true,
    state: {
        showTimePanel: false,
        formData: {
            'd_title': '',          //标题
            'd_time': '',           //起卦时间 
            'd_timeStr': '',        //起卦时间文本: 2022年05月12日 11:00
            'd_type': 1,            //起卦方式
        },
        formDataEdited: false,
        showChooseType: false,
        curDiagramChooseTypeData: consts.CONST_DIAGRAM_TYPE[0],
        curOrderIndex: 1,           //0全部记录,1最近浏览顺序,2起卦时间,3创建时间
        allRecordFilter: 0,         //0全部记录,
        diagramTimeOrder: 0,        //0顺序,1逆序
        createTimeOrder: 0,         //0顺序,1逆序
        diagramAllRecordOrder: 0,   //全部记录筛选index
        diagramAllRecordList: [],   //全部记录筛选列表
        showAllPanel: false,        //显示「全部记录」弹框
        showChooseLine: false,
        curChoosedLine: '',
        choosedLineData: {          //少阴:1,少阳:2,老阴:3,老阳:4
            one: 0, two: 0, three: 0, four: 0, five: 0, six: 0
        },
        choosedLineValue: 0,
        chooseDiagramType: '',      //本卦还是变卦的种类
        firstDiagramValue: '',      //本卦数值
        firstDiagramData: null,       //本卦数据
        firstDiagramFiltered: false,
        secondDiagramValue: '',     //变卦数值
        secondDiagramData: null,      //变卦数据
        secondDiagramFiltered: false,
        curDiagramInputNumber: '',  //输入的数字
        curChoosedCoper: 1,
        choosedCoperData: {
            one: 0, two: 0, three: 0, four: 0, five: 0, six: 0
        },
        diagramTitle: '',
        diagramBaseInfo: null,
        diagramDetailInfo: null,
        diagramDetailEdited: false,
        diagramTypeDataChanged: false,
        diagramTypeData: '',
        diagramData: null,
        diagramFromShare: false,
        qrCodeValue: '',
        showDetailImgPanel: false,
        diagramDetailChoosedImgIndex: 0,
        gotDiagramRecordData: false,
        gettingDiagramRecordList: false,
        diagramRecordPage: 1,
        diagramRecordList: [],
        diagramSearchList: [],
        diagramFilterList: [],
    },
    mutations: {
        [types.DIAGRAM_CONFIRM_TIME](state, params) {
            let dateInfo = DATA.getTimeInfoByInputData(params, 'datestrtime')
            state.formData = Object.assign(state.formData, {
                d_time: dateInfo[1],
                d_timeStr: dateInfo[0]
            });
            console.log('types.DIAGRAM_CONFIRM_TIME:::::::', params, state.formData)
        },
        [types.DIAGRAM_UPDATE_CHOOSED_COPER](state, lineType) {
            switch(state.curChoosedCoper) {
                case 1:
                    state.choosedCoperData = Object.assign(state.choosedCoperData, {
                        one: lineType
                    });
                    break;
                case 2:
                    state.choosedCoperData = Object.assign(state.choosedCoperData, {
                        two: lineType
                    });
                    break;
                case 3:
                    state.choosedCoperData = Object.assign(state.choosedCoperData, {
                        three: lineType
                    });
                    break;
                case 4:
                    state.choosedCoperData = Object.assign(state.choosedCoperData, {
                        four: lineType
                    });
                    break;
                case 5:
                    state.choosedCoperData = Object.assign(state.choosedCoperData, {
                        five: lineType
                    });
                    break;
                case 6:
                    state.choosedCoperData = Object.assign(state.choosedCoperData, {
                        six: lineType
                    });
                    break;
                default:
                    break;
            }
            state.curChoosedCoper = state.curChoosedCoper <= 6 ? state.curChoosedCoper+1 : state.curChoosedCoper;
            console.log('types.DIAGRAM_UPDATE_CHOOSED_COPER:::::::', lineType)
        },
        [types.DIAGRAM_COMPILE_DIAGRAM_TYPE_DATA](state) {
            let typeData = '';
            switch(state.diagramData.f_type) {
                case 1:
                    typeData = state.formData.d_time;
                    break;
                case 2:
                    typeData = Object.values(state.choosedLineData).join(',').toString();
                    break;
                case 3:
                    typeData = state.firstDiagramData.text+','+state.secondDiagramData.text;
                    break;
                case 4:
                case 5:
                case 6:
                    typeData = state.curDiagramInputNumber;
                    break;
                case 7:
                    typeData = Object.values(state.choosedCoperData).join(',').toString();
                    break;
                default:
                    break;
            }
            console.log('types.DIAGRAM_COMPILE_DIAGRAM_TYPE_DATA:::::::', state.diagramData, typeData);
            state.diagramTypeData = typeData;
        },
        [types.DIAGRAM_DECOMPILE_DIAGRAM_TYPE_DATA](state, dData) {
            let typeData = dData.f_type_data;
            switch(dData.f_type) {
                case 2:
                    let choosedArr = typeData.split(',');
                    state.choosedLineData = { one: choosedArr[0], two: choosedArr[1], three: choosedArr[2], four: choosedArr[3], five: choosedArr[4], six: choosedArr[5] };
                    break;
                case 3:
                    let digramArr = DIAGRAM_DATA_MANAGER.getDiagramDataByDiagramNameArr(typeData.split(','));
                    state.firstDiagramData = digramArr[0] ? digramArr[0] : null;
                    state.firstDiagramValue = digramArr[0] ? [digramArr[0].gong, digramArr[0].value].join('') : '';
                    state.secondDiagramData = digramArr[1] ? digramArr[1] : null;
                    state.secondDiagramValue = digramArr[1] ? [digramArr[1].gong, digramArr[1].value].join('') : '';
                    break;
                case 4:
                case 5:
                case 6:
                    state.curDiagramInputNumber = typeData;
                case 7:
                    let coperArr = typeData.split(',');
                    state.curChoosedCoper = 7;
                    state.choosedCoperData = { one: coperArr[0], two: coperArr[1], three: coperArr[2], four: coperArr[3], five: coperArr[4], six: coperArr[5] };
                    break;
                default:
                    break;
            }
        },
        [types.DIAGRAM_UPDATE_EDIT_FORM](state) {
            let dData = Object.assign({}, state.diagramData);
            let dateArr = MOMENT_TIME.getTimeArrayByTimeStamp(dData.f_time*1000);
            let dateInfo = DATA.getTimeInfoByInputData({
                year: dateArr[0], month: dateArr[1], day: dateArr[2], hour: dateArr[3], minute: dateArr[4]
            }, 'datestrtime');
            state.formData = Object.assign(state.formData, {
                d_title: dData.f_title,
                d_type: dData.f_type,
                d_time: dateInfo[1],
                d_timeStr: dateInfo[0]
            });
            state.curDiagramChooseTypeData = consts.CONST_DIAGRAM_TYPE[dData.f_type-1];
            console.log('types.DIAGRAM_UPDATE_EDIT_FORM:::::::', state.formData, state.diagramData);
        },
        [types.DIAGRAM_UPDATE_DIAGRAM_DETAIL_AND_LIST](state, params) {
            let newList = DIAGRAM_DATA_MANAGER.updateDiagramRecordList(state.diagramRecordList, params.dData);
            state.diagramRecordList = [].concat(newList);
        },
        [types.DIAGRAM_UPDATE_DIAGRAM_LIST](state, id) {
            state.diagramRecordList.forEach((el, index) => {
                if(el.id == id) {
                    state.diagramRecordList.splice(index, 1);
                }
            });
            if(state.diagramSearchList.length != 0) {
                state.diagramSearchList.forEach((el, index) => {
                    if(el.id == id) {
                        state.diagramSearchList.splice(index, 1);
                    }
                })
            }
            if(state.diagramFilterList.length != 0) {
                state.diagramFilterList.forEach((el, index) => {
                    if(el.id == id) {
                        state.diagramFilterList.splice(index, 1);
                    }
                })
            }
            if(state.diagramAllRecordList.length != 0) {
                state.diagramAllRecordList.forEach((el, index) => {
                    if(el.id == id) {
                        state.diagramAllRecordList.splice(index, 1);
                    }
                })
            }
        }
    },
    actions: {
        confirmDiagramTime({ commit }, inputData) {
            commit(types.DIAGRAM_CONFIRM_TIME, inputData)
        },
        updateDiagramChoosedCoper({ commit }, lineType) {
            commit(types.DIAGRAM_UPDATE_CHOOSED_COPER, lineType);
        },
        initDiagramRecordList({ state }, params) {
            // 防止重复拉取数据列表开关
            if(state.gettingDiagramRecordList) {
                return;
            }
            state.gettingDiagramRecordList = true;
            // 轮询
            function getData() {
                return new Promise((resolve, reject) => {
                    API.getGuaList({
                        page: state.diagramRecordPage
                    }, (data) => {
                        let curList = [].concat(data.info);
                            curList = curList.map(el => {return DIAGRAM_DATA_MANAGER.getDiagramRecordListDataByData(el) });
                            curList = curList.filter(el => {return el != null });
                        // console.log('获取卦列表成功-----', data.info, curList);
                        state.diagramRecordList = curList.concat(state.diagramRecordList);
                        let nowpage = parseInt(state.diagramRecordPage),
                            totalpage = parseInt(data.total.totalpage);
                        if(totalpage == 0 || nowpage == totalpage) {
                            state.gotDiagramRecordData = true;
                            state.gettingDiagramRecordList = false;
                            state.diagramRecordList = state.diagramRecordList.sort((a, b) => {return b.f_trigger_time - a.f_trigger_time})
                            console.log('卦列表拉完了', state.diagramRecordList)
                            if(params && params.cb && typeof(params.cb) == 'function') {
                                params.cb();
                            }
                        }else {
                            state.diagramRecordPage = nowpage+1;
                            curList.splice(0);
                        }
                        resolve();
                    }, () => {
                        state.gettingDiagramRecordList = false;
                        reject();
                    });
                }).catch((err) => {
                    console.error("课程卦列表数据失败::::::", err);
                });
            }
            function start() {
                async function timeFn() {
                    if(state.gotDiagramRecordData) {
                        if(params && params.cb && typeof(params.cb) == 'function') {
                            params.cb();
                        }
                        return;
                    }
                    await getData().then(function() {
                        setTimeout(timeFn, 100);
                    });
                }
                timeFn();
            }
            start();
        },
        startDiagram({ state }, params) {
            let formData = Object.assign({}, state.formData);
            let paramsData = {
                f_title: formData.d_title != '' ? formData.d_title : '未命名',
                f_type: formData.d_type,
                f_time: parseInt(formData.d_time),
                f_type_data: params.typeData == '' ? parseInt(formData.d_time) : params.typeData, //2024.04.23新增字段
                f_share_id: 0,
            }
            console.log('startDiagram-----', formData, paramsData);
            API.addGua(paramsData, (ret) => {
                console.log('起卦成功-----', ret)
                // 展示卦数据
                let diagramData = DIAGRAM_DATA_MANAGER.getDiagramDataByData(ret);
                state.diagramData = Object.assign(ret, diagramData);
                state.diagramTitle = ret.f_title;
                state.diagramBaseInfo = Object.assign({}, diagramData.baseInfo);
                state.diagramDetailInfo = Object.assign({}, diagramData.detailInfo);
                state.qrCodeValue = 'https://' + location.hostname + '/share/diagramdetail/' + ret.share_code;
                // 更新卦列表
                let recordData = DIAGRAM_DATA_MANAGER.getDiagramRecordListDataByData(ret);
                state.diagramRecordList = [recordData].concat(state.diagramRecordList);
                // console.log('recordData------', state.diagramRecordList);
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb(ret.id);
                }
            })
        
        },
        startRecordDiagram({ commit, state }, params) {
            API.getGuaInfoById({
                id: params.diagramData.id
            }, (gRet)=> {
                console.log('获取卦信息成功::::::', gRet);
                let diagramData = DIAGRAM_DATA_MANAGER.getDiagramDataByData(gRet);
                state.diagramData = Object.assign(params.diagramData, diagramData);
                state.diagramTitle = params.diagramData.f_title;
                state.diagramBaseInfo = Object.assign({}, diagramData.baseInfo);
                state.diagramDetailInfo = Object.assign({}, diagramData.detailInfo);
                state.qrCodeValue = 'https://' + location.hostname + '/share/diagramdetail/' + params.diagramData.share_code;
                commit(types.DIAGRAM_DECOMPILE_DIAGRAM_TYPE_DATA, params.diagramData);
                // 更新查看时间
                API.setGuaRecent({
                    id: params.diagramData.id
                }, (ret)=> {
                    console.log("更新查看卦的时间:::", ret);
                    // 更新卦列表
                    commit(types.DIAGRAM_UPDATE_DIAGRAM_DETAIL_AND_LIST, {dData: Object.assign(params.diagramData, ret)});
                    state.diagramRecordList = state.diagramRecordList.sort((a, b) => {return b.f_trigger_time - a.f_trigger_time});

                    if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                        params.sucCb();
                    }
                })
            }, ()=> {
                console.error('获取卦信息失败')
            })
        },
        deleteDiagram({ commit }, id) {
            console.log('deleteDiagram-----', id)
            API.deleteGua({
                id: id
            }, (ret) => {
                console.log("删除卦成功----", ret)
                commit(types.DIAGRAM_UPDATE_DIAGRAM_LIST, id);
            })
        },
        updateDiagramEditForm({ commit }) {
            commit(types.DIAGRAM_UPDATE_EDIT_FORM);
        },
        saveDiagramEdit({ commit, state }, params) {
            let eParams = {id: state.diagramData.id};
            console.log('saveDiagramEdit----', params, eParams, state.diagramData);
            if(params.type == 'base') { //基础数据修改:标题,时间,卦象
                eParams = Object.assign(eParams, {
                    f_title: state.formData.d_title,
                    f_time: state.formData.d_time
                });
                // 重新编辑了卦
                if(state.diagramTypeDataChanged) {
                    commit(types.DIAGRAM_COMPILE_DIAGRAM_TYPE_DATA); //重新初始化other
                    eParams = Object.assign(eParams, {
                        f_type_data: state.diagramTypeData,
                    })
                }
            }else if(params.type == 'detail') { //描述类数据修改:占卦描述、断卦分析、结果定案、复盘分析
                // if(params.value == '') { return; }
                let newParams = {}; newParams[params.key] = params.value;
                eParams = Object.assign(eParams, newParams);
            }
            console.log('saveDiagramEdit----', eParams)
            // return;
            API.updateGua(eParams, (ret)=> {
                console.log('更新卦信息成功-------', ret)
                // 更新卦和卦列表数据
                state.diagramTitle = ret.f_title;
                if(params.type == 'base' && state.diagramTypeDataChanged) { //改了卦象要重新获取卦信息
                    API.getGuaInfoById({
                        id: state.diagramData.id
                    }, (gRet)=> {
                        console.log('获取卦信息成功::::::', gRet);
                        let diagramData = DIAGRAM_DATA_MANAGER.getDiagramDataByData(gRet);
                        state.diagramData = Object.assign(state.diagramData, diagramData);
                        state.diagramBaseInfo = Object.assign({}, diagramData.baseInfo);
                        state.diagramDetailInfo = Object.assign({}, diagramData.detailInfo);
                        commit(types.DIAGRAM_DECOMPILE_DIAGRAM_TYPE_DATA, Object.assign(state.diagramData, {f_type_data: state.diagramTypeData}));
                        let newData = Object.assign(state.diagramData, DIAGRAM_DATA_MANAGER.getDiagramRecordListDataByData(ret));
                        console.error('newData------', newData);
                        commit(types.DIAGRAM_UPDATE_DIAGRAM_DETAIL_AND_LIST, {dData: newData});
                        if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                            params.sucCb();
                        }
                    })
                    return;
                }
                // 没有改卦象
                commit(types.DIAGRAM_UPDATE_DIAGRAM_DETAIL_AND_LIST, {dData: Object.assign(state.diagramData, DIAGRAM_DATA_MANAGER.getDiagramRecordListDataByData(ret))});
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            });
        },
        autoSaveSharedDiagram({ commit, state }, params) {
            let dData = Object.assign({}, state.diagramData);
            let paramsData = {
                f_share_id: dData.id,
                f_title: dData.f_title,
                f_type: dData.f_type,
                f_type_data: dData.f_type_data,
                f_time: dData.f_time,
                f_describe: dData.f_describe,
                f_analyse: dData.f_analyse,
                f_fb_img: dData.f_fb_img,
                f_fb_status: dData.f_fb_status,
                f_feedback: dData.f_feedback,
                f_review: dData.f_review
            };
            console.log('autoSaveSharedDiagram-----', state.diagramData, paramsData);
            // return;
            API.addGua(paramsData, (gData) => {
                console.log('自动保存卦成功-----', gData)
                // 更新卦和卦列表数据
                let diagramData = DIAGRAM_DATA_MANAGER.getDiagramDataByData(gData);
                state.diagramFromShare = false;
                state.diagramData = Object.assign(gData, diagramData);
                state.diagramTitle = gData.f_title;
                state.diagramBaseInfo = Object.assign({}, diagramData.baseInfo);
                state.diagramDetailInfo = Object.assign({}, diagramData.detailInfo);
                state.qrCodeValue = 'https://' + location.hostname + '/share/diagramdetail/' + gData.share_code;

                commit(types.DIAGRAM_DECOMPILE_DIAGRAM_TYPE_DATA, state.diagramData);
                // 更新卦列表:不用更新，因为会重新拉一下的
                // let recordData = DIAGRAM_DATA_MANAGER.getDiagramRecordListDataByData(gData);
                // state.diagramRecordList = [recordData].concat(state.diagramRecordList);
                // console.log('update------', dData, state.diagramRecordList)
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb(gData);
                }
            }, (ret) => {
                if(ret.status_code == 9600) {
                    if(params && params.failCb && typeof(params.failCb) == 'function') {
                        params.failCb();
                    }
                }
            })
        },
        updateDiagramFbImg({ commit, state }, params) {
            console.log('updateDiagramFbImg---', params)
            let eParams = {id: state.diagramData.id};
            let dImgArr = state.diagramData.f_fb_img_arr;
            if(!params.params) { return; }
            if(params.params.type == 'add') {
                dImgArr = dImgArr.concat(params.params.urlList);
            }else if(params.params.type == 'delete') {
                dImgArr.splice(params.params.index, 1)
            }
            eParams = Object.assign(eParams, {
                f_fb_img: dImgArr.join(',')
            });
            API.updateGua(eParams, (ret)=> {
                console.log('更新卦信息成功-------', ret)
                commit(types.DIAGRAM_UPDATE_DIAGRAM_DETAIL_AND_LIST, {dData: Object.assign(state.diagramData, DIAGRAM_DATA_MANAGER.getDiagramRecordListDataByData(ret))});
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            });
        },
        initDiagramInfo({ commit, state }, params) {
            console.log('initDiagramInfo----', params)
            API.getGuaInfo({
                share_code: params.dCode
            }, (ret) => {
                console.log('获取卦信息成功-------', ret)
                let diagramData = DIAGRAM_DATA_MANAGER.getDiagramDataByData(ret);
                state.diagramFromShare = true;
                state.diagramData = Object.assign(ret, diagramData);
                state.diagramTitle = ret.f_title;
                state.diagramBaseInfo = Object.assign({}, diagramData.baseInfo);
                state.diagramDetailInfo = Object.assign({}, diagramData.detailInfo);
                state.qrCodeValue = 'https://' + location.hostname + '/share/diagramdetail/' + ret.share_code;

                commit(types.DIAGRAM_DECOMPILE_DIAGRAM_TYPE_DATA, state.diagramData);
            })
        },
        confirmSearchDiagram({ commit, state }, text) {
            state.curOrderIndex = 1;
            state.diagramAllRecordOrder = 0;
            let tempList = [].concat(state.diagramRecordList);
                tempList = tempList.filter(data => data.f_title.toLowerCase().indexOf(text.toLowerCase()) !== -1);
            state.diagramSearchList = [].concat(tempList);
            console.log('confirmSearchDiagram-----', text, tempList)
        },
        filterRecordByDiagram({ state }, params) {
            let type = params.type, all = params.all;
            if(type == 'first') {
                state.firstDiagramFiltered = !all;
            }else if(type == 'second') {
                state.secondDiagramFiltered = !all;
            }
            let tempList = [].concat(state.diagramRecordList);
                tempList = state.firstDiagramFiltered ? tempList.filter(data => data.f_oname == state.firstDiagramData.text) : tempList;
                tempList = state.secondDiagramFiltered ? tempList.filter(data => data.f_cname == state.secondDiagramData.text) : tempList;
            state.diagramFilterList = [].concat(tempList);
            console.log('filterRecordByDiagram-----', type, tempList)
        },
        orderDiagramRecordByType({ state }, params) {
            let type = params.type;
            console.log('orderDiagramRecordByType-----', params)
            switch(type) {
                case 'recent':
                    state.curOrderIndex = 1;
                    state.diagramRecordList = state.diagramRecordList.sort((a, b) => {return b.f_trigger_time - a.f_trigger_time})
                    break;
                case 'diagramtime':
                    state.curOrderIndex = 2;
                    state.diagramTimeOrder = state.diagramTimeOrder == 0 ? 1 : 0;
                    if(state.diagramTimeOrder == 0) {
                        state.diagramRecordList = state.diagramRecordList.sort((a, b) => {return b.f_time - a.f_time})
                    }else if(state.diagramTimeOrder == 1) {
                        state.diagramRecordList = state.diagramRecordList.sort((a, b) => {return a.f_time - b.f_time})
                    }
                    break;
                case 'createtime':
                    state.curOrderIndex = 3;
                    state.createTimeOrder = state.createTimeOrder == 0 ? 1: 0;
                    if(state.createTimeOrder == 0) {
                        state.diagramRecordList = state.diagramRecordList.sort((a, b) => {return b.createtimestamp - a.createtimestamp})
                    }else if(state.createTimeOrder == 1) {
                        state.diagramRecordList = state.diagramRecordList.sort((a, b) => {return a.createtimestamp - b.createtimestamp})
                    }
                    break;
                default:
                    break;
            }
        },
        filterAllRecordByType({ state }, type) {
            state.diagramAllRecordOrder = type;
            if(type == 0) {
                state.diagramAllRecordList = [];
            }else if(type == 1) {
                state.diagramAllRecordList = state.diagramRecordList.filter(el => {return el.hasFb})
            }else if(type == 2) {
                state.diagramAllRecordList = state.diagramRecordList.filter(el => {return !el.hasFb})
            }else if(type >= 3) {
                // console.error('type=====', type)
                state.diagramAllRecordList = state.diagramRecordList.filter(el => {return el.f_type+2==type})
            }
            console.log('filterAllRecordByType-----', type)
        },
        resetDiagramFormData({ state }) {
            state.curDiagramChooseTypeData = consts.CONST_DIAGRAM_TYPE[0];
            state.curChoosedLine = '',
            state.choosedLineData = {          //少阴:1,少阳:2,老阴:3,老阳:4
                one: 0, two: 0, three: 0, four: 0, five: 0, six: 0
            };
            state.choosedLineValue = 0;
            state.chooseDiagramType = '';
            state.firstDiagramData = null;          //本卦数据
            state.firstDiagramValue = '';           //本卦数值
            state.firstDiagramFiltered = false;     //本卦筛选
            state.secondDiagramData = null;         //变卦数据
            state.secondDiagramValue = '';          //变卦数值
            state.secondDiagramFiltered = false;    //变卦筛选
            state.curDiagramInputNumber = '';       //输入的数字
            state.curChoosedCoper = 1;
            state.choosedCoperData = {
                one: 0, two: 0, three: 0, four: 0, five: 0, six: 0
            };
        },
        resetDiagramInfo({ state }) {
            state.formData = {
                'd_title': '',          //标题
                'd_time': '',           //起卦时间 
                'd_timeStr': '',        //起卦时间文本: 2022年05月12日 11:00
                'd_type': 1,            //起卦方式
            };
            state.formDataEdited = false;
            state.diagramTitle = '';
            state.diagramBaseInfo = null;
            state.diagramDetailInfo = null;
            state.diagramDetailEdited = false;
            state.diagramTypeDataChanged = false;
            state.diagramTypeData = '';
            state.diagramData = null;
            state.diagramFromShare = false;
            state.qrCodeValue = '';
            state.showDetailImgPanel = false;
            state.diagramDetailChoosedImgIndex = 0;
        },
        resetDiagramChoosedCoper({ state }) {
            state.curChoosedCoper = 1;
            state.choosedCoperData = {
                one: 0, two: 0, three: 0, four: 0, five: 0, six: 0
            };
        }
    }
}
